import { Navigate, Route, Routes } from "react-router-dom";

import { Layout } from "./chrome/Layout";
import { ConfirmEmailPage } from "./pages/confirm-email/ConfirmEmailPage";
import { RepositoriesGrid } from "./pages/dashboard/RepositoriesGrid";
import { JoinPage } from "./pages/join/JoinPage";
import { NewAgent } from "./pages/new-agent/NewAgent";
import { NotFound } from "./pages/NotFound";
import { ActivityView } from "./pages/repo/ActivityView";
import { RepoView } from "./pages/repo/RepoView";
import { RoutinesView } from "./pages/routines/RoutinesView";
import { RunnersView } from "./pages/runners/RunnersView";
import { RepoSettings } from "./pages/settings/RepoSettings";
import { Settings } from "./pages/settings/Settings";
import { TaskView } from "./pages/task/TaskView";

export const App = () => (
  <Routes>
    {/* Public: enrollment (create a passkey) + invite accept. AuthGate lets this
        path through unauthenticated — a new user has no passkey to sign in with. */}
    <Route element={<JoinPage />} path="/join" />
    {/* Public: where an email-change confirmation link lands. The emailed token
        is the credential, and the link goes to the address being confirmed —
        which may be read in a browser this account never signed in from. */}
    <Route element={<ConfirmEmailPage />} path="/confirm-email" />
    <Route element={<Layout />}>
      <Route element={<Navigate replace to="/repos" />} path="/" />
      <Route element={<RepositoriesGrid />} path="/repos" />
      <Route element={<ActivityView />} path="/activity" />
      <Route element={<RunnersView />} path="/runners" />
      {/* The fleet surface was renamed Workers → Runners (runners.md
          §Terminology). The old URL redirects rather than 404s, for anyone
          who bookmarked it. */}
      <Route element={<Navigate replace to="/runners" />} path="/workers" />
      <Route element={<NewAgent />} path="/new" />
      <Route element={<RepoView />} path="/repos/:repoId" />
      <Route element={<NewAgent />} path="/repos/:repoId/new" />
      <Route element={<RoutinesView />} path="/repos/:repoId/routines" />
      <Route element={<RepoSettings />} path="/repos/:repoId/settings" />
      <Route element={<TaskView />} path="/repos/:repoId/tasks/:taskId" />
      <Route element={<TaskView />} path="/repos/:repoId/tasks/:taskId/:tab" />
      <Route
        element={<TaskView />}
        path="/repos/:repoId/tasks/:taskId/:tab/:sub"
      />
      <Route element={<Settings />} path="/settings" />
      <Route element={<NotFound />} path="*" />
    </Route>
  </Routes>
);
